import type { CodeSent } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

export function updateProfileName(name: string): Promise<void> {
  return api<void>('/account/profile', { method: 'PATCH', body: JSON.stringify({ name }) });
}

/** A code goes to the new address; the address is saved only once that code comes back (`completeEmailChange`). */
export function startEmailChange(email: string): Promise<CodeSent> {
  return api<CodeSent>('/account/email/send-code', { method: 'POST', body: JSON.stringify({ email }) });
}

export function completeEmailChange(code: string): Promise<void> {
  return api<void>('/account/email', { method: 'POST', body: JSON.stringify({ code }) });
}

/** `phone` as typed (0712 345 678); the server stores it in E.164. Saved only once the code sent to it comes back. */
export function startPhoneChange(phone: string): Promise<CodeSent> {
  return api<CodeSent>('/account/phone/send-code', { method: 'POST', body: JSON.stringify({ phone }) });
}

export function completePhoneChange(code: string): Promise<void> {
  return api<void>('/account/phone', { method: 'POST', body: JSON.stringify({ code }) });
}
